import {
  createAction,
  createSlice,
  type PayloadAction,
} from "@reduxjs/toolkit";
import type { IResourceLinks } from "../../InterfacesTypes/interfaces";

export interface ResourceLinksState {
  resourceLinksItems: IResourceLinks[];
  loading: boolean;
  error: string | null;
}

const initialState: ResourceLinksState = {
  resourceLinksItems: [],
  loading: false,
  error: null,
};
export const fetchResourceLinks = createAction(
  "resourceLinks/fetchResourceLinks"
);

export const resourceLinksSlice = createSlice({
  name: "resourceLinks",
  initialState,
  reducers: {
    fetchStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess(state, action: PayloadAction<IResourceLinks[]>) {
      state.loading = false;
      state.resourceLinksItems = action.payload;
    },
    fetchFailure(state, action: PayloadAction<string | null | undefined>) {
      state.loading = false;
      state.error = action.payload ?? "Något gick fel";
    },
    setResourceLinks(state, action: PayloadAction<IResourceLinks[]>) {
      state.resourceLinksItems = action.payload;
    },
  },
});

export const { fetchStart, fetchSuccess, fetchFailure, setResourceLinks } =
  resourceLinksSlice.actions;

export const resourceLinksReducer = resourceLinksSlice.reducer;
